module.exports = __webpack_public_path__ + "img/11_19.0672d809.png";